<template>
  <div>
    <div class="d-flex flex-row justify-content-center align-items-center">
      <a class="btn btn-join btn-line d-flex align-items-center mx-1" href="https://lin.ee/xuVds1R" target="_blank">
        <i class="fab fa-line"></i>
        加入好友
      </a>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.btn-join {
  padding: 3px 5px;
}

.btn-line {
  background-color: #06c755;
  color: white;
  border: none;
  border-radius: 5px;
}

.btn-mail {
  background-color: #8B8D91;
}
</style>
